<template>

<div class="collapsible">
    <div class="trigger">
        <div class="row align-items-center">
            <div class="col-auto">
                <div class="trigger-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter"><polygon points="22 3 2 3 10 12.36 10 19 14 21 14 12.36"></polygon></svg>
                </div>
            </div>
            <div class="col">
                <div class="trigger-content">Filtros Ultimas Noticias</div>
            </div>
        </div>
    </div>
    <div class="body">
        <div class="card social-media">
                <div class="card-content">
                    <div class="container">
                        <div class="row element">
                                <div class="col-sm-12 col-md-12 col-lg-12" >
                                    <div class="mi-select-egm" :class="{ 'select-open': entidadOpen }">
                                    <v-select :value="entidad" :reduce="(option) => option.value" :searchable="false" :filterable="false"
                                        :clearable="true" class="style-chooser" :options="options3" @input="setSelectedRegion"
                                        @open="entidadOpen = true" @close="entidadOpen = false"
                                        placeholder="Todas las entidades">
                                    </v-select>
                                    </div>
                                </div>
                        </div>
                        <div class="row element">
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="mi-select-egm">
                                    <v-select :value="grupo" :reduce="(option) => option.value" :searchable="false" :filterable="false"
                                        :clearable="true" class="style-chooser" :options="dataGrupos" @input="setSelectedGrupo"
                                        placeholder="Todos los grupos">
                                    </v-select>
                                    </div>
                                </div>
                        </div>
                        <div class="row element action">
                            <div class="col-auto content-col justify-content-center">
                                <button class="button small" @click="saveFiltersConfiguration()">
                                    <span>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>                                   
    </div>
</div>
</template>

<script>
import { cond } from 'lodash';

export default {
    name: 'filtros',
    data() {
        return {
            url: this.$store.getters.getMainUrl,
            selectedEntity: '',
            entidades: {
                activo: false,
                id: null,
                nombre: null,
            },
            selecGrupo: {
                activo: false,
                label: false,
                id: null,
            },
            options3: [],
            entidad: null,
            entidadOpen: false,
            grupo: null,
            cogp: null,
            toggleSelect: false,
            publicidad: false,
            dataGrupos: [],
        }
    },
    beforeMount() {
        this.getMediaGroups();
        this.getMediaRegiones();
        this.getConfigNoticias();
    },
    methods: {
        saveFiltersConfiguration() {
            console.log("guardar configuración")
            //saveConfigUltimasNoticias
            console.log("entidad", this.entidades);
            console.log("grupo", this.selecGrupo);

            var self = this;
            var eventData = {
                token: self.token,
                entidad: self.entidades,
                grupo: self.selecGrupo,
            };
            axios
                //.post(self.url + "getMediaGroups", JSON.stringify({ token: self.token,  self.entidades, this.selecGrupo }))
                .post(self.url + "saveConfigUltimasNoticias", JSON.stringify(eventData))
                .then(response => {
                    console.log("respuesta guardar configuración")
                    console.log(response);
                if (response.data.success) {
                    console.log("configuración guardada")
                } else {
                    condole.log("error al guardar configuración")
                }

                })
                .catch(function (error) {
                self.error(error);
                });
        },
        getMediaGroups() { ///EGM290823
            //sliders de canales
            console.log("grupos")
            var self = this;
            //var arrFavs = [];
            axios
                .post(self.url + "getMediaGroups", JSON.stringify({ token: self.token, medio: ""}))
                .then(response => {
                if (response.data.success) {
                    self.dataGrupos = self.dataGrupos.concat(response.data.data) //EGM290823
                    //self.items = response.data.result;
                } else {
                    //self.items = [].concat(self.items, response.data.result);
                }

                })
                .catch(function (error) {
                self.error(error);
                });
        },
        getMediaRegiones() {
        ///EGM290823
        //sliders de canales
        this.options3 = [];
        var self = this;
        //var arrFavs = [];
        axios
            .post(
            self.url + "getMediaCiudadRegion",
            JSON.stringify({ token: self.token, medio: this.medio, grupo: 0 })
            )
            .then((response) => {
            console.log("-------------------HERRE");
            console.log(response.data);
            //self.ready = true;
            if (response.data.success) {
                self.options3 = response.data.data; //EGM290823
                //self.items = response.data.result;
            } else {
                //self.items = [].concat(self.items, response.data.result);
            }
            })
            .catch(function (error) {
            self.error(error);
            });
        },
        setSelectedRegion(value) {
        this.online = true;
        this.medioOfline = false;
        this.favoritos = false;
        this.entidades["activo"] = true;
        this.entidades["id"] = value;
        this.entidades["nombre"] = this.options3.find(option => option.value === value).label || null;
        this.entidad = value;
        },
        setSelectedGrupo(value) {
        //console.log("=======seleccion canale",datos.value)
        this.online = true;
        this.medioOfline = false;
        this.favoritos = false;
        this.selecGrupo["activo"] = true;
        this.selecGrupo["id"] = value;
        this.selecGrupo["label"] = this.dataGrupos.find(option => option.value === value).label || null;
        this.grupo = value;
        },
        async getConfigNoticias() {
            try {
                var post_data = {
                    token: this.token
                };

                const response = await axios.post(
                this.url + "getConfigUltimasNoticias",
                JSON.stringify(post_data)
                );
                console.log("Datos recibidos CONFIG:", response.data.data.data);
                //return response.data.data; // Retorna los datos para su uso
                if (response.data.success) {
                    this.entidad = response.data.data.data.entidad.id;
                    this.grupo = response.data.data.data.grupo.id;
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
                throw error; // Propaga el error para manejarlo fuera
            }
        },
    }
}
</script>

<style scoped>
.collapsible {
    overflow: visible !important;
}

.body {
    overflow: visible !important;
}

.card {
    overflow: visible !important;
}

.card-content {
    overflow: visible !important;
}

.container {
    overflow: visible !important;
}

.mi-select-egm {
    position: relative;
    z-index: 1000;
    overflow: visible !important;
    transition: z-index 0.2s ease;
}

.mi-select-egm.select-open {
    z-index: 10000 !important;
}

.style-chooser {
    z-index: 1000 !important;
}

.vs__dropdown-toggle {
    z-index: 1000 !important;
}

.vs__dropdown-menu {
    z-index: 10000 !important;
}

.col-save-user{
    text-align:center;
}
.button-save-user{
    background: #00b99e;
    color:#FFF;
}
.button-save-user:hover{
    background: #EBF9FF;
    color:#062633;
}
</style>